<template>
  <div class="website-wrapper">
    <iframe :src="src" :width="width" :height="height" frameborder="0"></iframe>
  </div>
</template>

<script>
import $pubsub from "../utils/pubsub.js";
export default {
  name: "web-site",
  props: ["name", "wid", "hih"],
  data() {
    return {
        src: null
    }
  },
  computed: {
    width() {
        return this.wid - 4
    },
    height() {
        return this.hih - 4
    }
  },
  mounted() {
    const store = $pubsub();
    const id = Number(this.name.split("_")[1]);
    const modal = store.getter("modals").find((item) => item.id === id);
    const option = store.getter("options")[modal.optionName];
    this.src = option.address;
  }
};
</script>

<style lang="scss" scoped>
.website-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: content-box;
}
</style>
